import * as React from 'react';

import type {DisplayOptionEntity} from 'nutshell-core/utils';
import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import {AccountCardCreateable} from 'shells/peep-cards/account-card/account-card-createable/account-card-createable';

import type {AccountCreateInput, AccountUpdateInput} from 'nutshell-graphql-types';

import {refetchForEvent} from '../../../refetch-helpers';

import {getPotentialAccounts} from '../../../../core/form/fields/peeps/accounts/rich-account-select-helpers';
import type {AccountInput} from '../../../../peep/account-hierarchy/utils';

type Props = {
    leadId: string;
    onClose: () => void;
    onCreate: (arg1: AccountCreateInput) => Promise<any>;
    onUpdate: (arg1: AccountUpdateInput) => Promise<any>;
    errorProps: {
        error: string | null | undefined;
        setError: (error?: string | null | undefined) => void;
    };
    alreadyAddedAccountIds: string[] | null | undefined;
};

export function CompanyRowCreateForm(props: Props) {
    const handleCreateCompany = (input: AccountInput) => {
        const newCompany: AccountCreateInput = {
            name: input.name,
            description: input.description,
            ...(input.address && input.address.trim()
                ? {
                      addresses: [
                          {
                              name: 'address',
                              address: {},
                              singleLineAddress: input.address.trim(),
                          },
                      ],
                  }
                : undefined),
            leads: [{id: props.leadId}],
        };

        props
            .onCreate(newCompany)
            .then(() => {
                refetchForEvent('accountsUpdated');
            })
            .catch((e) => {
                props.errorProps.setError(safelyGetGraphQLErrorMessage(e));
            });
        props.onClose();
    };

    const handleAddCompany = (account: DisplayOptionEntity) => {
        const newCompany: AccountUpdateInput = {
            accountId: account.id,
            name: account.value,
            leads: [{id: props.leadId}],
        };

        props
            .onUpdate(newCompany)
            .then(() => {
                refetchForEvent('accountsUpdated');
            })
            .catch((e) => {
                props.errorProps.setError(safelyGetGraphQLErrorMessage(e));
            });
        props.onClose();
    };

    return (
        <AccountCardCreateable
            onSelectAccount={handleAddCompany}
            onSubmit={handleCreateCompany}
            onSearchPotentialAccounts={(input: AccountInput) =>
                getPotentialAccounts({
                    accountInput: input,
                    alreadyAddedAccounts: props.alreadyAddedAccountIds,
                })
            }
            onClose={props.onClose}
            isPotentialAccountsPopover={true}
        />
    );
}
